export const Account = () => `/account`;
export const AccountRecovery = () => `/account/password`;
export const Dashboard = () => `/dashboard`;
export const Help = () => `/help`;
export const Home = () => `/`;
export const Login = () => `/login`;
export const Logout = () => `/logout`;
export const Register = plan => `/register${plan ? `/${plan}` : ""}`;
export const Subscription = () => `/subscription`;
export const WebsiteEditAnalytics = id => `/website/${id}/analytics`;
export const WebsiteEditContent = id => `/website/${id}/content`;
export const WebsiteEditContentStep = (id, step) => `/website/${id}/content/${step}`;
export const WebsiteEditDesign = id => `/website/${id}/design`;
export const WebsiteEditDomain = id => `/website/${id}/domain`;
export const WebsiteEditECommerce = id => `/website/${id}/content/ecommerce`;
export const WebsiteEditMarketing = id => `/website/${id}/marketing`;
export const WebsiteNew = () => `/website/new`;

export const WizardPublish = () => `/wizard/publish`;
export const WizardSave = () => `/wizard/save`;
